import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { chartColor, CHART_STATUS_COLORS } from '../../../styles/chartColors';

const SurveyProgressDonut = ({ percent, completed, total }) => {
  const isComplete = percent >= 100;
  const data = isComplete
    ? [{ key: 'done', value: 100 }]
    : [
        { key: 'done', value: percent },
        { key: 'remaining', value: 100 - percent },
      ];

  return (
    <div className="survey-donut">
      <ResponsiveContainer width="100%" height={260}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            innerRadius={90}
            outerRadius={120}
            startAngle={90}
            endAngle={-270}
            stroke="none"
            isAnimationActive={false}
          >
            <Cell fill={chartColor(0)} />
            {!isComplete && <Cell fill={CHART_STATUS_COLORS.track} />}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="survey-donut-label">{percent}%</div>
      <div className="survey-donut-caption">{completed} of {total} responded</div>
    </div>
  );
};

export default SurveyProgressDonut;
